import { z } from "zod";
import { IdSchema, IsoDateTimeSchema } from "../common/primitives.js";
const TaxRegimeSchema = z.enum(["real", "flat_rate"]);
const WithholdingStatusSchema = z.enum(["legal_entity", "real_regime", "other"]);
const RibSchema = z.string().transform((v) => v.replace(/\s+/g, "")).pipe(z.string().regex(/^\d{20}$/, "a RIB has 20 digits"));
const BankDetailsInputSchema = z.strictObject({
  bankName: z.string().trim().min(1).max(100),
  rib: RibSchema
});
const CreateFiscalProfileRequestSchema = z.strictObject({
  /** When this version starts to apply; now when absent. */
  effectiveFrom: IsoDateTimeSchema.optional(),
  vatRegistered: z.boolean(),
  taxRegime: TaxRegimeSchema,
  withholdingStatus: WithholdingStatusSchema,
  invoiceFooter: z.string().trim().max(1e3).optional(),
  bankDetails: BankDetailsInputSchema.optional(),
  defaultSeriesId: IdSchema.optional()
});
const FiscalProfileSchema = z.strictObject({
  id: IdSchema,
  effectiveFrom: IsoDateTimeSchema,
  /** The version that applies now. */
  current: z.boolean(),
  vatRegistered: z.boolean(),
  taxRegime: TaxRegimeSchema,
  withholdingStatus: WithholdingStatusSchema,
  invoiceFooter: z.string().nullable(),
  /** Masked: bank name and the last 4 digits only. */
  bankDetails: z.strictObject({ bankName: z.string(), ribMasked: z.string() }).nullable(),
  defaultSeriesId: IdSchema.nullable(),
  createdBy: z.strictObject({ id: IdSchema, displayName: z.string() }),
  createdAt: IsoDateTimeSchema
});
const FiscalProfileListSchema = z.strictObject({
  items: z.array(FiscalProfileSchema).max(500)
});
const FiscalProfileParamsSchema = z.strictObject({ orgId: IdSchema, profileId: IdSchema });
const BankDetailsSchema = z.strictObject({
  bankName: z.string(),
  rib: z.string(),
  /** TN59 + RIB. */
  iban: z.string()
});
const InvoiceSeriesSchema = z.strictObject({
  id: IdSchema,
  code: z.string(),
  prefix: z.string(),
  resetYearly: z.boolean(),
  isDefault: z.boolean(),
  version: z.int().min(1)
});
const InvoiceSeriesListSchema = z.strictObject({
  items: z.array(InvoiceSeriesSchema).max(100)
});
const SeriesCodeSchema = z.string().trim().toUpperCase().regex(/^[A-Z0-9]{1,10}$/, "1 to 10 letters or digits");
const SeriesPrefixSchema = z.string().trim().min(1).max(20);
const CreateInvoiceSeriesRequestSchema = z.strictObject({
  code: SeriesCodeSchema,
  prefix: SeriesPrefixSchema,
  resetYearly: z.boolean().default(true),
  isDefault: z.boolean().default(false)
});
const UpdateInvoiceSeriesRequestSchema = z.strictObject({
  prefix: SeriesPrefixSchema,
  resetYearly: z.boolean(),
  /** Only `true`: making another series the default unsets this one. */
  isDefault: z.literal(true)
}).partial().refine((body) => Object.keys(body).length > 0, "change at least one field");
const InvoiceSeriesParamsSchema = z.strictObject({ orgId: IdSchema, seriesId: IdSchema });
export {
  BankDetailsInputSchema,
  BankDetailsSchema,
  CreateFiscalProfileRequestSchema,
  CreateInvoiceSeriesRequestSchema,
  FiscalProfileListSchema,
  FiscalProfileParamsSchema,
  FiscalProfileSchema,
  InvoiceSeriesListSchema,
  InvoiceSeriesParamsSchema,
  InvoiceSeriesSchema,
  RibSchema,
  TaxRegimeSchema,
  UpdateInvoiceSeriesRequestSchema,
  WithholdingStatusSchema
};
//# sourceMappingURL=index.js.map